
export class BankAccount {
    id: string;
    accountNumber: string;
    iban: string;
    swiftCode: string;
    bankName: string;
    description: string;
    customerId: string;
    isActive: string;
}